import React from "react";

type Props = {
  className?: string;
};

const CheckBadgeIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.75 10.786L9 13.036L12.75 7.786M9.75 0.75C7.48574 2.90023 4.47026 4.07958 1.348 4.036C0.950839 5.24598 0.748976 6.51151 0.750004 7.785C0.750004 13.377 4.574 18.075 9.75 19.408C14.926 18.076 18.75 13.378 18.75 7.786C18.75 6.476 18.54 5.215 18.152 4.035H18C14.804 4.035 11.9 2.787 9.75 0.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckBadgeIcon;
